var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcVegetarian(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.887,
    height: 41.681,
    viewBox: "0 0 26.887 41.681",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.055 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.375 12.066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.744,1.924A4.971,4.971,0,0,1,6.687,0H5A5.007,5.007,0,0,0,0,4.785H1.688A4.973,4.973,0,0,1,2.744,1.924Z",
    transform: "translate(10.389 0.051)",
    fill: "#d84a4a",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.954,21.1,4.192,10.048h.246a.591.591,0,0,0,0-1.181H3.9L3.69,8.038H4.941a.591.591,0,1,0,0-1.181H3.394L2.182,2.01H3.333a.591.591,0,0,0,0-1.181H1.887L1.742.249C1.722.166,1.7.083,1.688,0H0C.016.083.034.166.055.249L.2.828H1.645a.591.591,0,0,1,0,1.181H.495L1.707,6.857H3.253a.591.591,0,1,1,0,1.181H2l.207.828h.542a.591.591,0,0,1,0,1.181H2.5L5.267,21.1a1.011,1.011,0,0,0,.19.384l.059.074A1,1,0,0,0,7.123,21.5c.006-.009.011-.019.017-.028a1.012,1.012,0,0,1-.186-.379Z",
    transform: "translate(10.481 6.016)",
    fill: "#d84a4a",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.181H1.688A.591.591,0,1,0,1.688,0H0A.591.591,0,0,1,.591.591.591.591,0,0,1,0,1.181Z",
    transform: "translate(13.835 4.835)",
    fill: "#d84a4a",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.812,2.18,3.614,1.1A.591.591,0,0,0,3.005.085L2.212.562a.591.591,0,0,1-.285.535L0,2.255l.208.208.8-.48a.591.591,0,0,1,.807.2Z",
    transform: "translate(1.119 14.921)",
    fill: "#d84a4a",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.714,3.819A3.468,3.468,0,0,1,3.38,1.251L4.628.5a3.5,3.5,0,0,1,.955-.4A3.464,3.464,0,0,0,2.94.5l-1.248.75A3.494,3.494,0,0,0,.347,5.762l1.407-.846a3.5,3.5,0,0,1-.04-1.1Z",
    transform: "translate(0.082 10.452)",
    fill: "#d84a4a",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.764,7.527l-5.008-5a.591.591,0,0,0-.629-1L1.9,1.67l-.208-.208L2.295,1.1A.591.591,0,0,0,1.686.085L.893.562A.591.591,0,0,1,.608,1.1L0,1.462l.208.208L.44,1.53a.591.591,0,0,1,.629,1L6.807,8.256a.569.569,0,0,0,.206.132l.065.024a.573.573,0,0,0,.741-.724Z",
    transform: "translate(5.399 19.986)",
    fill: "#d84a4a",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.687,1.424,2.232,1.1A.591.591,0,0,0,1.623.084L.83.562A.591.591,0,0,1,.544,1.1L0,1.424,2.347,3.767l.86-.517a.588.588,0,0,1,.229-.079Z",
    transform: "translate(2.189 16.82)",
    fill: "#d84a4a",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.87,29.439l-.059-.074a2.176,2.176,0,0,1-.414-.834L.185,7.683A6.183,6.183,0,0,1,6.184,0h2a6.183,6.183,0,0,1,6.046,7.478L9.713,28.533a2.185,2.185,0,0,1-2.066,1.726H7.565A2.161,2.161,0,0,1,5.87,29.439Z",
    transform: "translate(12.58 10.935)",
    fill: "#d84a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.032,10.346.122,3.38a2.6,2.6,0,1,1,4.961,0L3.171,10.346a.59.59,0,0,1-1.138,0Z",
    transform: "translate(17.159 0.001)",
    fill: "#d84a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.173,5.727a.591.591,0,0,1-.1-.71L2.362,1.005A1.876,1.876,0,1,1,4.894,3.537L.883,5.822a.59.59,0,0,1-.71-.1Z",
    transform: "translate(20.992 4.808)",
    fill: "#d84a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.935,6.771.958,3.512A1.876,1.876,0,1,1,3.544,1.018c0,.008.008.016.012.025L5.846,6.069a.591.591,0,0,1-.912.7Z",
    transform: "translate(12.569 3.803)",
    fill: "#d84a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.47.085.286.8A.591.591,0,0,0,.9,1.808L2.078,1.1A.591.591,0,0,0,1.47.085Z",
    transform: "translate(10.697 25.79)",
    fill: "#0635c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.281.085l-.994.6A.591.591,0,1,0,.9,1.7l.995-.6A.591.591,0,1,0,1.281.085Z",
    transform: "translate(11.265 27.273)",
    fill: "#0635c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.385,26.322l-.065-.024a1.745,1.745,0,0,1-.63-.4L3.592,14.817a4.672,4.672,0,0,1,.893-7.31l.239-.144a.59.59,0,0,1-.22-.131L.691,3.6A2.057,2.057,0,1,1,4.056,1.572L5.48,6.645a.588.588,0,0,1,.013.257l.24-.144c.061-.037.122-.071.184-.1-.013,0-.025,0-.038-.007a.59.59,0,0,1-.447-.559l-.08-3.365a1.529,1.529,0,1,1,2.833.706L6.538,6.362l-.01.014A4.671,4.671,0,0,1,12.56,9.246l5.1,14.862a1.753,1.753,0,0,1-2.27,2.215Z",
    transform: "translate(0.055 15.249)",
    fill: "#425966"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVegetarian);
export default __webpack_public_path__ + "static/media/ic_vegetarian.8492fb5b70affc98a0a5c577ed1deea9.svg";
export { ForwardRef as ReactComponent };